import { useMatomo } from '@/composables/useMatomo';
import { defineStore } from 'pinia';

export const useGeneralStore = defineStore('general', {
  state: () => ({
    isLoading: true,
    isSaving: false,
    activeContentView: null,
    activeViewType: null,
    dimmer: -1,
    currentDate: {},
    idleCount: 0,
  }),
  actions: {
    setLoading(loading) {
      this.isLoading = loading;
    },
    setSaving(saving) {
      this.isSaving = saving;
    },
    setActiveContentView(activeContentView) {
      this.activeContentView = activeContentView;
    },
    setActiveViewType(activeViewType) {
      this.activeViewType = activeViewType;
      const { trackEvent } = useMatomo();
      trackEvent('Select', 'ViewType', activeViewType);
    },
    setDimmer(dimmer) {
      if (!dimmer) {
        // If localStorage value is empty, parseInt returns -1
        dimmer = parseInt(localStorage.getItem('dimmer')) || 100;
      }

      localStorage.setItem('dimmer', dimmer);
      this.dimmer = dimmer;
    },
    setCurrentDate(date) {
      this.currentDate = date;
    },
    setIdle() {
      this.idleCount += 1;
    },
  },
});
